export class PeriodicCandidate {
	public candidate;
	
	constructor(obj) {
		this.candidate = obj.candidate;
	}
} 
